import { API_BASE_URL } from './apiConfig';

/**
 * Получает полный URL для изображения
 * Поддерживает как относительные пути от API, так и полные URL
 *
 * @param imagePath - Путь к изображению (например '/uploads/dishes/dish-123.jpg') или null
 * @returns Полный URL для изображения или null если путь не задан
 *
 * @example
 * getImageUrl('/uploads/dishes/dish-123.jpg')
 * // => 'http://localhost:3000/uploads/dishes/dish-123.jpg'
 *
 * getImageUrl(null)
 * // => null
 */
export const getImageUrl = (imagePath: string | null | undefined): string | null => {
  if (!imagePath) {
    return null;
  }

  // Если это уже полный URL, вернуть как есть
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Если это относительный путь, добавить базовый URL
  return `${API_BASE_URL}${imagePath}`;
};
